import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';

import HelpIconImage from '@/assets/images/icons/help-icon.svg';
import { Faqcomponent } from '@/common/components/Faq/FaqComponent';
import { LandingPageFaq } from '@/utils/constants/forex/faq';
import type { ForexService } from '@/utils/constants/forex/forexServices';
import ForexServices from '@/utils/constants/forex/forexServices';

import CallbackForm from '../../CallBackForm';
import { TransactionProcess } from '../../enums';
import ForexEasySteps from '../../LandingPage/ForexEasySteps';
import ReasonsUseForex from '../../LandingPage/ReasonsUseForex';
import LeadForm from '../../LeadForm';
import { ForexPastTransactions } from '../reusables/PastTransactions';
import type { LeadStore } from './PreLogin';

export const PostLoginLandingPage = () => {
  const [currentTab, setCurrentTab] = useState<string>('BUY');
  const [activeStep, setActiveStep] = useState<number>(1);
  const [leadState, setLeadState] = useState<LeadStore>({
    items: [],
    userDetails: {
      userName: '',
      userEmail: '',
      userPhone: '',
      userCity: '',
      userState: '',
    },
    transactionProcess: TransactionProcess.Online,
  });

  const handleActiveStep = (step: number) => {
    setActiveStep(step);
  };

  return (
    <>
      <main className="home pledge loanDetails buyGold repayment">
        <section className="bg bg--light mt-lg-3 mt-2">
          <div className="container">
            <div className="row">
              <div className="col-lg-7 visitSchedule">
                <div className="fx-landing">
                  <ul className="nav nav-tabs-trans fx-nav-border">
                    {ForexServices.slice(0, 3).map((service: ForexService) => (
                      <li
                        className="nav-item nav-item-flink nav-list-item"
                        key={service.id}
                      >
                        <a
                          className={`nav-link nav-tab-li nav-link-padding fx-nav-link fx-tab-item ${
                            currentTab === service.activeTab
                              ? 'forex-tab-active'
                              : 'list-color'
                          }`}
                          data-toggle="tab"
                          onClick={() => {
                            setCurrentTab(service.activeTab);
                            setActiveStep(1);
                            setLeadState({
                              items: [],
                              userDetails: {
                                userName: '',
                                userEmail: '',
                                userPhone: '',
                                userCity: '',
                                userState: '',
                              },
                              transactionProcess: TransactionProcess.Online,
                            });
                          }}
                        >
                          {/* <p className="text--bold"> */}
                          {service.title}
                          {/* </p> */}
                        </a>
                      </li>
                    ))}
                  </ul>
                  <ul className="nav nav-tabs-trans fx-nav-border mt-3 gap-2">
                    {ForexServices.slice(3, 5).map((service: ForexService) => (
                      <li
                        className="nav-item nav-item-flink nav-list-item fx-load-items"
                        key={service.id}
                      >
                        <a
                          className={`nav-link nav-tab-li nav-link-padding fx-nav-link fx-tab-item ${
                            currentTab === service.activeTab
                              ? 'forex-tab-active'
                              : 'list-color'
                          }`}
                          data-toggle="tab"
                          onClick={() => {
                            setCurrentTab(service.activeTab);
                            setActiveStep(1);
                            setLeadState({
                              items: [],
                              userDetails: {
                                userName: '',
                                userEmail: '',
                                userPhone: '',
                                userCity: '',
                                userState: '',
                              },
                              transactionProcess: TransactionProcess.Online,
                            });
                          }}
                        >
                          {/* <p className="text--bold"> */}
                          {service.title}
                          {/* </p> */}
                        </a>
                      </li>
                    ))}
                  </ul>

                  {/* <LeadForm
                    type={currentTab}
                    activeStep={activeStep}
                    handleStep={handleActiveStep}
                    key={currentTab}
                    setLeadState={setLeadState}
                    leadState={leadState}
                    isAvailServices={true}
                  /> */}

                  {activeStep === 1 && (
                    <LeadForm
                      type={currentTab}
                      activeStep={activeStep}
                      handleStep={handleActiveStep}
                      key={currentTab}
                      setLeadState={setLeadState}
                      leadState={leadState}
                      isAvailServices={false}
                    />
                  )}
                  {activeStep === 2 && (
                    <CallbackForm
                      activeStep={activeStep}
                      handleStep={handleActiveStep}
                      leadState={leadState}
                      setLeadState={setLeadState}
                    />
                  )}
                </div>
              </div>
              <div className="col-lg-5 mt-lg-0 mt-3">
                <ForexPastTransactions />
                <Link
                  href="/help"
                  className="loanDetails__card loanCard actionCard"
                  id="DG_help"
                >
                  <div className="left">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={HelpIconImage}
                      alt="help icon"
                      width={32}
                      height={32}
                    />
                    <p className="loanCard__title text--bold text--black mb-0">
                      Help &amp; Support
                    </p>
                  </div>
                  <div className="right">
                    <span className="circleArrow-icon"></span>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </section>
        <ForexEasySteps />
        <ReasonsUseForex />
        <Faqcomponent faqData={LandingPageFaq()} />
      </main>
    </>
  );
};
